import { useEffect } from 'react';
import {
	useFlatList,
	useIssueIds,
	useChildIssueIds,
	useFlatListIssueKeys,
} from '@atlassian/jira-issue-table-hierarchy/src/controllers/hierarchy/index.tsx';
import { expVal } from '@atlassian/jira-feature-experiments';

const EMPTY_ARRAY: string[] = [];

type Props = {
	onIssueFlatListUpdated?: (
		newFlatKeyList: string[],
		newFlatIdList: string[],
		newFlatChildIdList: string[],
	) => void;
};

export const FlatListUpdateHandler = ({ onIssueFlatListUpdated }: Props) => {
	const flatList = useFlatList();
	const flatListIssueKeys = useFlatListIssueKeys();
	const flatListIssueIds = useIssueIds();
	const flatListChildIssueIds = expVal('bulk_ops_select_all_beyond_experiment', 'isEnabled', false)
		? // eslint-disable-next-line react-hooks/react-compiler
			// eslint-disable-next-line react-hooks/rules-of-hooks
			useChildIssueIds()
		: EMPTY_ARRAY;

	useEffect(() => {
		// eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-data-to-parent
		onIssueFlatListUpdated?.(
			flatListIssueKeys.filter(Boolean),
			flatListIssueIds,
			flatListChildIssueIds,
		);
	}, [
		flatList,
		flatListIssueIds,
		flatListIssueKeys,
		onIssueFlatListUpdated,
		flatListChildIssueIds,
	]);

	return null;
};
